module.exports = __webpack_public_path__ + "static/media/logo.e0f6ce2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/logo.png
// module id = ./src/assets/media/logo.png
// module chunks = 16